<template>
    <div class=" divide-y dividr-gray-200">
        <SkeletonBase
            hasTitle
            :content="2"
            hasButton
        />
        <SkeletonBase
            hasTitle
            :content="2"
            hasButton
        />
        <SkeletonBase
            hasTitle
            :table="3"
            hasButton
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
